import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';

@Component({
  selector: 'app-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss']
})
export class ExamplesComponent implements OnInit {

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService
  ) { }

  ngOnInit() {
    this.titleService.setTitle('高级写作提高示例-Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'Trinka可帮助您使自己的文章更贴近读者。 它不仅检查语法，而且检查诸如语调，风格，可读性和客观性等高级写作特性。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '高级语法检查，学术写作语法检查工具，技术写作检查，学术写作助手，技术写作助手' });
    this.metaTagService.updateTag({ property: 'og:title', content: '高级写作提高示例-Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka可帮助您使自己的文章更贴近读者。 它不仅检查语法，而且检查诸如语调，风格，可读性和客观性等高级写作特性。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/examples' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/examples' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/examples' });

    if (isPlatformBrowser(this.platformId)){
      $.getScript('../../../assets/js/wisepop.js', function(){});
    }
  }

}
